module.exports = {
  FormWrapper: require('./components/FormWrapper'),
  FormSubmitBtn: require('./components/FormSubmitBtn'),
  FormAdditionalBtn: require('./components/FormAdditionalBtn'),
  FormFooter: require('./components/FormFooter'),
  FormFooterAgreement: require('./components/FormFooterAgreement'),

  // this needs to be done so YUP get the default texts for basic errors
  yupParams: require('./utils/yupParams'),
  fileSchema: require('./utils/yupParams').fileSchema,
}
